
import cusDateTime from '@/components/cusDateTime';
import XTable from 'vux/src/components/x-table/index.vue'

import { Toast, MessageBox } from 'mint-ui';
export default {
name: "assessment-view",
props: ['dataId', 'dataImg','isEdit'],
components:{cusDateTime, XTable},
data() {
return {
isSupplier:false,
orderObj: {},
gridList: [
{icon: require('@/assets/icon/supplier/supplier_base_data.png'), label: '基本信息'},
{icon: require('@/assets/icon/supplier/bidding_detail.png'), label: '订单明细'},
{icon: require('@/assets/icon/supplier/supplier_base_data.png'), label: '其它费用(抬头)'},
{icon: require('@/assets/icon/supplier/com_order_details.png'), label: '收货地址'},
{icon: require('@/assets/icon/supplier/com_order_flow.png'), label: '流程信息'},
],
index: 1,
checkPriceDiffMap: {},
requiredCenterManagerPerson: false,
actNodeId: '',
purFreights: []
}
},
methods: {
beforeValid(cb) {

if (this.checkPriceDiffMap && Object.keys(this.checkPriceDiffMap).length > 0) {
let multiple = 0;
let multipleKey = '';
for (let key in this.checkPriceDiffMap) {
const data = this.checkPriceDiffMap[key];
if (Number(data.multiple || 0) >= 5) {
multiple = Number(data.multiple || 0);
multipleKey = key;
}
}
const nodes = ['P7', 'P8', 'P9']
if ((multiple >= 5 && nodes.includes(this.actNodeId)) || (this.actNodeId === 'send' || this.actNodeId === 'P1')) {
const keys = Object.keys(this.checkPriceDiffMap);
multipleKey = multiple >= 5 && nodes.includes(this.actNodeId) ? multipleKey : keys[0];
MessageBox.confirm(this.checkPriceDiffMap[multipleKey].msg, '提示').then(action => {
if (action === 'confirm') {
cb && cb(true);
}
}).catch(() => {
cb && cb(false);
});
} else {
cb && cb(true);
}
} else {
cb && cb(true);
}
},
valid(){
if(this.isSupplier && this.isEdit){
if(!(this.orderObj.supplierReply || this.orderObj.supplierReply === false)){
this.$vux.toast.text('请在基本信息中选择回复意见');
return false;
}
}
return true;
},
formData() {
return this.orderObj;
},
changeCellShow(list, i) {
if (list[i].cellShow) {
this.$set(list[i], 'cellShow', false);
return;
}
this.$set(list[i], 'cellShow', true);
},
itemTab(index) {
this.index = index;
if(index === 5){
this.$emit('changeFlowInfo',true);
}else{
this.$emit('changeFlowInfo',false);
}
},
getOrderDto() {
this.$loadingShow();
this.$get('api/purOrderApprove/' + this.dataId).then((data) => {
if (data) {
console.log("2323232",data)
this.orderObj = data;
const requestBase = data && data.requestBase;
this.actNodeId = requestBase && requestBase.workflowNodeBase && requestBase.workflowNodeBase.actNodeId;
this.purFreights = data.purFreights;
this.compireAllOrderPrice();
}
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
},
compireAllOrderPrice(){

this.orderObj.orderDetails && this.orderObj.orderDetails.forEach(item => {
this.compireOrderPrice(item)
});
},

compireOrderPrice(item){
if (!item.perPrice) {
return;
}
const data = {
price: item.perPrice,
plantCode: item.plantCode,
unit: item.unit,
matCode: item.matCode,
id: item.purRequisition ? item.purRequisition.id : item.id
}

this.$post('api/purOrderApprove/checkOrderPriceDifference', data).then((res) => {
const nodes = ['send', 'P1', 'P7', 'P8', 'P9'];
if (nodes.includes(this.actNodeId)) {
if (res && res.msg) {
Toast({
message: res.msg,
position: 'top',
duration: 3000
});
this.requiredCenterManagerPerson = this.actNodeId == 'P8' && Number(res.multiple || 0) >= 5;
this.checkPriceDiffMap[`${data.plantCode}_${data.id}`] = res;
} else {
delete this.checkPriceDiffMap[`${data.plantCode}_${data.id}`];
}
} else {
this.checkPriceDiffMap = {}
}
});
},
changeOrd(orderDetail) {
if (orderDetail.show) {
this.$set(orderDetail, 'show', false);
return;
}
this.$set(orderDetail, 'show', true);
},
switchTabItem(e, info) {
e['list'] = info;
this.$forceUpdate();
},
getPerson(){
this.$get('api/person/current').then((res) => {
if(res.userType === '0'){
this.isSupplier = true;
}else{
this.isSupplier = false;
}
})
}
},
mounted() {
this.getPerson();
if (this.dataId) {
this.getOrderDto();
}
},
watch: {
dataId() {
if (this.dataId) {
this.getOrderDto();
}
}
}
}



// WEBPACK FOOTER //
// ./src/page/purchase-order/purchase-order-approve-check.vue